import { useCallback, useRef } from "react";
import useFetch from "@entrilia/shared/hooks/useFetch";
import useSetInterval from "@entrilia/shared/hooks/useSetInterval";
import { logError } from "@entrilia/shared/logging";
import biApi from "../../../../api/biApi";
import { isFinishedStatus } from "../runs/workbookRunUtils";

const FETCH_INTERVAL_MS = 2000;

const useWorkbookRunPolling = (runId: string) => {
  const isPollingRef = useRef(false);
  const getWorkbookRun = useCallback((signal?: AbortSignal) => biApi.getWorkbookRun(runId, signal), [runId]);
  const [workbookRun, fetchError, { setData: setWorkbookRun, fetchSilent }] = useFetch(getWorkbookRun);

  const pollWorkbookRun = useCallback(async () => {
    if (isPollingRef.current) {
      return;
    }

    isPollingRef.current = true;
    const error = await fetchSilent();
    isPollingRef.current = false;
    if (error) {
      logError(error, "[useWorkbookRunPolling] getWorkbookRun");
    }
  }, [fetchSilent]);

  useSetInterval(pollWorkbookRun, FETCH_INTERVAL_MS, {
    disabled: workbookRun === undefined || isFinishedStatus(workbookRun.status),
  });

  return { workbookRun, setWorkbookRun, fetchError };
};

export default useWorkbookRunPolling;
